const subAbas = [
  { label: 'Contratos', rota: '/fornecedor/contratos/contratos' },
];

export default subAbas;
